import { createAsyncThunk } from "@reduxjs/toolkit";

export const resetPassword = createAsyncThunk(
    "[USER] resetPassword",
    async (email: object, thunk: { extra: any }) => {
        return await thunk.extra.userQuery.resetPassword(email);
    }
)